/** Lola, la lorita 🦜 — mascota guía del flujo de evaluación (un loro = repetir).
 *  SVG inline extraído de docs/referencias-ui, sin dependencias de imagen. */
import styles from "./Mascot.module.css";

export function Mascot({ size = 120, float = true }: { size?: number; float?: boolean }) {
  return (
    <div
      className={[styles.mascota, float ? styles.float : ""].filter(Boolean).join(" ")}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 120 120" width="100%" height="100%" role="img" aria-label="Lola, la lorita">
        <ellipse cx="60" cy="70" rx="38" ry="42" fill="#0E7C86" />
        <ellipse cx="60" cy="80" rx="24" ry="28" fill="#E9F5F9" />
        <ellipse cx="34" cy="72" rx="14" ry="24" fill="#FFB443" transform="rotate(18 34 72)" />
        <circle cx="60" cy="34" r="24" fill="#0E7C86" />
        <circle cx="52" cy="30" r="6.5" fill="#fff" />
        <circle cx="52" cy="30" r="3" fill="#16333B" />
        <path d="M66 26 q16 -2 14 12 q-2 10 -14 8 z" fill="#FF6B6B" />
        <path d="M66 40 q10 2 12 -2 l-2 8 q-6 2 -10 -2z" fill="#E85454" />
        <path d="M40 14 q4 -10 12 -6 q-2 2 -4 8" fill="#FFB443" />
      </svg>
    </div>
  );
}

export function SpeechBubble({ children }: { children: React.ReactNode }) {
  return <div className={styles.bubble}>{children}</div>;
}
